export const MERCHANT_CREDIT_TYPES = [
  { id: 3, name: 'Gift Card' },
  { id: 10, name: 'Electronic Gift Card' },
] as const
export const MERCHANT_CREDIT_TYPE_NAME_MAP = MERCHANT_CREDIT_TYPES.reduce<
  Record<string, (typeof MERCHANT_CREDIT_TYPES)[number]>
>((accumulator, channelListingExceptionType) => {
  accumulator[channelListingExceptionType['name']] = channelListingExceptionType
  return accumulator
}, {})
export const MERCHANT_CREDIT_TYPE_ID_MAP = MERCHANT_CREDIT_TYPES.reduce<
  Record<string, (typeof MERCHANT_CREDIT_TYPES)[number]>
>((accumulator, channelListingExceptionType) => {
  accumulator[channelListingExceptionType['id']] = channelListingExceptionType
  return accumulator
}, {})
